import React, { lazy } from 'react'
import { JournalEnquiryDetail } from './JournalEnquiryDetails'

const JournalEnquiryListing = lazy(() =>
  import('./JournalEnquiryListing').then(module => ({
    default: module.JournalEnquiryListing,
  }))
)

const ExternalJournalFilter = lazy(() =>
  import('../../../components/Filter/ExternalJournalFilter').then(module => ({
    default: module.ExternalJournalFilter,
  }))
)

const journalEnquiryRoutes = [
  {
    props: {
      exact: true,
      path: '/general-ledger/:CompanyID/journal-enquiry',
    },
    component: <JournalEnquiryListing />,
  },

  {
    props: {
      exact: true,
      path: '/general-ledger/:CompanyID/journal-enquiry/:JournalID/detail',
    },
    component: <JournalEnquiryDetail />,
  },
  {
    props: {
      exact: true,
      path: '/general-ledger/:CompanyID/journal-enquiry/filter',
    },
    component: (
      <ExternalJournalFilter
        mode="journal-enquiry"
        app="general-ledger"
        hasDocNo
        hasRefNo
        hasDesc
      />
    ),
  },
]

export default journalEnquiryRoutes
